import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from 'react-router-dom';

import MainLayout from './components/MainLayout/MainLayout';
import LoginPage from './pages/LoginPage/LoginPage';
import RegisterPage from './pages/RegisterPage/RegisterPage';

// Основные страницы внутри MainLayout
import CheckPage from './pages/CheckPage/CheckPage';
import GuidePage from './pages/GuidePage/GuidePage';
import DBHouse from './pages/info/DBHouse/DBHouse';
import DBCollectors from './pages/info/DBCollectors/DBCollectors';
import DBSeries from './pages/info/DBSeries/DBSeries';
import CheckDetails from './pages/CheckPage/CheckDetails';
import EditFailurePage from './pages/CheckPage/EditFailurePage';
import HouseDetails from './pages/info/DBHouse/HouseDetails';
import EditHouseDetails from './pages/info/DBHouse/EditHouseDetails';
import CollectorsDetails from './pages/info/DBCollectors/CollectorsDetails';
import EditCollectorsDetails from './pages/info/DBCollectors/EditCollectorsDetails';
import EditDBSeries from './pages/info/DBSeries/EditDBSeries';
import SummaryReportsPage from './pages/SummaryReportsPage/SummaryReportsPage';
import MapPage from './components/Markers/MapPage';


function App() {
  const location = useLocation();

  const isLoginPage =
    location.pathname === '/' ||
    location.pathname === '/login' ||
    location.pathname === '/register';

  return (
    <div>
      {isLoginPage ? (
        <Routes>
          <Route path="/" element={<LoginPage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/register" element={<RegisterPage />} />
        </Routes>
      ) : (
        <Routes>
          <Route element={<MainLayout />}>
            <Route path="/collectors" element={<MapPage />} />
            <Route path="/expenses" element={<MapPage />} />
            <Route path="/pipeline" element={<MapPage />} />
            <Route path="/check" element={<CheckPage />} />
            <Route path="/guide" element={<GuidePage />} />
            <Route path="/db-collectors" element={<DBCollectors />} />
            <Route path="/db-series" element={<DBSeries />} />
            <Route path="/check" element={<CheckPage />} />
            <Route path="/check/:id" element={<CheckDetails />} />
            <Route path="/check/:id/edit" element={<EditFailurePage />} />
            <Route path="/db-house" element={<DBHouse />} />
            <Route path="/db-house/:id" element={<HouseDetails />} />
            <Route path="/edit-house" element={<EditHouseDetails />} />
            <Route path="/collectors/:id" element={<CollectorsDetails />} />
            <Route path="/edit-collector" element={<EditCollectorsDetails />} />
            <Route path="/edit-db-series/:seriesId" element={<EditDBSeries />} />
            <Route path="/summary-reports" element={<SummaryReportsPage />} />
          </Route>
        </Routes>
      )}
    </div>
  );
}

export default function RouterApp() {
  return (
    <Router>
      <App />
    </Router>
  );
}
